import GridRowLabel from './GridRowLabel';

export default GridRowLabel;
